/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_cognito_identity_pool_id": "eu-central-1:1f245e53-e15c-41c4-87be-5ec14696c3a5",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_5saPw6ah4",
    "aws_user_pools_web_client_id": "6ls5ianrfbrg0rc4f5217dce66",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_appsync_graphqlEndpoint": "https://ezl7v4b7zja63hx4smxigv3yhy.appsync-api.eu-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-central-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-ie35rsq52zd3hn6nz5zbj4y6c4",
    "aws_user_files_s3_bucket": "arec-recordings231127-dev",
    "aws_user_files_s3_bucket_region": "eu-central-1"
};


export default awsmobile;
